import { render, staticRenderFns } from "./AppGantt.vue?vue&type=template&id=1071aa1e&"
import script from "./AppGantt.vue?vue&type=script&lang=js&"
export * from "./AppGantt.vue?vue&type=script&lang=js&"
import style0 from "./AppGantt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports